// TODO: Remove from `core-js@4`
var $ = require('../internals/export');
var global = require('../internals/global');
var uncurryThis = require('../internals/function-uncurry-this');

var Date = global.Date;
var getTime = uncurryThis(Date.prototype.getTime);

// `Date.now` method
// https://tc39.es/ecma262/#sec-date.now
$({ target: 'Date', stat: true }, {
  now: function now() {
    return getTime(new Date());
  }
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.date.now.js
// module id = 296
// module chunks = 0